import { ENCODER_GUIDES } from './source-config';

export default function ModalAddSource(
  $uibModalInstance,
  $rootScope,
  BoxCaster,
  toaster,
  StaticRTMP,
  MeetingsService,
  $state,
  $http,
  $timeout,
  parentVM,
  sourceToAdd,
  onlyShowEncoderGuides,
  params
) {
  'ngInject';
  this.StaticRTMP = StaticRTMP;
  this.BoxCaster = BoxCaster;
  this.sourceToAdd = sourceToAdd;
  this.onlyShowEncoderGuides = onlyShowEncoderGuides;
  this.staticRTMPChannels = parentVM.staticRTMPs;
  this.allowRtmp = parentVM.allowRtmp;
  this.allowBroadcaster = parentVM.allowBroadcaster;
  this.staticRTMPChannelLimit = parentVM.account.static_rtmps_channel_limit;
  this.account = parentVM.account;
  this.user = parentVM.user;
  this.limits = $rootScope.ApiConfig.modelFieldLimits('static_rtmp', 'maximum');
  this.downloadBroadcasterURL =
    'https://itunes.apple.com/us/app/broadcaster-smarter-way-to/id1105581053';

  // XXX; $http is presenting CORS issues reading from assets.boxcast.com, but
  // neither fetch nor XMLHttpRequest do.  I attempted to remove the auth
  // interceptor code for this, and even that does not change the behavior.
  // After fighting for too long with it, I'm just giving up and using
  // XMLHttpRequest
  this.backorderMessages = {};
  var req = new XMLHttpRequest();
  var self = this;
  req.addEventListener('load', function () {
    var data = JSON.parse(this.responseText);
    $timeout(() => {
      self.backorderMessages = data.backorder_messages || {};
    });
  });
  req.open('GET', 'https://assets.boxcast.com/inventory.json');
  req.send();

  if (params && params.name) {
    this.rtmpChannelName = params.name;
  }

  this.refresh = () => {
    this.boxcaster = {};
    this.detectedBox = this.BoxCaster.getRegistration(() => {
      if (
        (this.detectedBox.id[0] == 'p' && this.sourceToAdd == 'boxcaster-pro') ||
        (this.detectedBox.id[0] == 'o' && this.sourceToAdd == 'boxcaster') ||
        !this.sourceToAdd
      ) {
        this.boxcaster.id = this.detectedBox.id;
      }
    });
  };

  this.refresh();

  this.cancel = () => $uibModalInstance.dismiss('cancel');

  this.registerBoxCaster = () => {
    if (!this.boxcaster.id) {
      toaster.pop('warning', 'Please enter the BoxCaster serial number');
      return;
    }
    this.saving = true;
    this.BoxCaster.postRegistration(
      {},
      { id: this.boxcaster.id },
      () => {
        this.saving = false;
        $uibModalInstance.dismiss();
        parentVM.refresh();
      },
      () => {
        this.saving = false;
        toaster.pop(
          'warning',
          'There was an error trying to register your BoxCaster. Please double-check the serial number and try again.'
        );
      }
    );
  };

  this.createRtmpChannel = () => {
    if (!this.rtmpChannelName) {
      toaster.pop('warning', 'Please enter a name for your RTMP source.');
      return;
    }
    this.saving = true;
    this.StaticRTMP.create(
      { name: this.rtmpChannelName },
      (r) => {
        this.saving = false;
        $uibModalInstance.dismiss();
        // insert the new source into the list of sources
        parentVM.allSources.push(r);
        // re-sort the list so the newly added source is in the correct position in the list
        parentVM.sortSources(parentVM.allSources, parentVM.broadcastsByStaticRTMP);
        // Ideally, we would update the query params here to keep the new source active in case they refresh the page, or want to link someone to the page at this point in time
        // Changing query params through $location and window.location both cause this controller to make fresh API calls to the server...
        // **IN PRODUCTION ONLY**, those responses do not contain this newly created source so we need to make sure those API calls to not get sent
        // $location.search('static_rtmp_id', r.id);
        parentVM.toggleDetails(r);
      },
      (err) => {
        this.saving = false;
        console.log(err);
        toaster.pop('warning', 'There was an error creating your RTMP source.');
      }
    );
  };

  this.onContactUs = () => {
    if (this.account.contract == 'trial') {
      MeetingsService.openPreferredMethod();
    } else {
      MeetingsService.scheduleMeeting('Schedule time to discuss purchasing a BoxCaster');
    }
  };

  this.select = (name, params = {}) => {
    if (params && params.action) {
      if (params.action == 'downloadBroadcasterApp') {
        window.open(this.downloadBroadcasterURL, '_blank');
        return false;
      }
    } else {
      this.sourceToAdd = name;
      if (name.startsWith('boxcaster')) {
        this.refresh();
      }
      if (name == 'rtmp' && params.name) {
        this.rtmpChannelName = params.name;
      }
    }
  };

  this.RTMP_ENCODER_GUIDES = ENCODER_GUIDES;
}



// WEBPACK FOOTER //
// ./app/pages/sources/modal-add-source.js